module.exports = __webpack_public_path__ + "static/splatoon-duizhen-5275aa8376acd1e2331cf00dbd306f5d.png";